import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';

import clip from '@/utils/clipboard'; // use clipboard directly
import phone from '@/assets/landscape-phone.png';
import { makeDebugUrl } from '@/api/qa/task';
import PreviewDevice from '@/components/PreviewDevice/index.vue';
import { isProduction } from '@com/config/env';
import { addQueryString } from '@com/utils/url';
import { mindworkURL } from '@/common/mindworkURL';

export default {
  components: {
    PreviewDevice: PreviewDevice
  },
  props: {
    preview: {
      type: Object,
      default: function _default() {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    previewSource: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      mobileBg: phone,
      type: 2,
      iframeWidth: 386,
      iframeHeight: 822,
      className: 'g-landscape-wrap',
      inlineClassName: 'g-landscape-preview',
      debug_html_url: '',
      generateCnLoading: false,
      generateDebugUrlLoading: false,
      env: isProduction ? 0 : 1 // test=[生产环境=0][测试环境/本地=1]
    };
  },

  computed: {
    innerPreview: function innerPreview() {
      return _Object$assign({
        defaultUrl: true,
        showMwUrl: true,
        showCnUrl: false,
        showDebugUrl: false
      }, _extends({}, this.preview));
    },

    // category_id：分类 id
    itavideo: function itavideo() {
      return Number(this.preview.category_id) === 4;
    },
    innerPreviewHtmlUrl: function innerPreviewHtmlUrl() {
      var html_url = this.innerPreview.default_html_url || this.innerPreview.html_url;
      var url = addQueryString(html_url, {
        preview: true,
        itavideo: this.itavideo ? '1' : '2',
        mw_test: this.env,
        loading: 1
      });
      return url;
    },
    viewInnerPreviewHtmlUrl: function viewInnerPreviewHtmlUrl() {
      var html_url = this.innerPreview.default_html_url || this.innerPreview.html_url;
      var url = addQueryString(html_url, {
        preview: true,
        itavideo: this.itavideo ? '1' : '2',
        mw_test: this.env,
        mock: Number(this.preview.traffic_type) === 13 ? 'true' : '',
        debug: Number(this.preview.traffic_type) === 13 ? 'true' : '',
        loading: 1
      });
      return url;
    }
  },
  watch: {
    type: function type(val) {
      if (Number(val) === 1) {
        this.className = 'g-landscape-wrap';
        this.inlineClassName = 'g-landscape-preview';
        this.iframeWidth = 822;
        this.iframeHeight = 386;
      } else {
        this.className = 'g-portrait-preview';
        this.inlineClassName = '';
        this.iframeWidth = 386;
        this.iframeHeight = 822;
      }
    },
    'preview.visible': function previewVisible(val) {
      if (val) {
        this.type = 2;
        this.debug_html_url = this.preview.debug_html_url;
      } else {
        this.debug_html_url = '';
        // eslint-disable-next-line vue/no-mutating-props
        this.preview.html_url = '';

        if (this.preview.hasOwnProperty('default_html_url')) {
          // eslint-disable-next-line vue/no-mutating-props
          this.preview.default_html_url = '';
        }
      }
    }
  },
  methods: {
    handleCopy: function handleCopy(text, event) {
      var url = '' + text;
      clip(url, event);
    },
    getMindworkURL: function getMindworkURL() {
      return mindworkURL({
        url: this.preview.default_html_url || this.innerPreview.html_url,
        itavideo: this.itavideo ? '1' : '2',
        orientation: this.preview.orientation,
        name: this.preview.title,
        language: this.preview.language,
        env: this.env,
        isHttp: this.previewSource === 'basic'
      });
    },
    generateDebugUrl: function generateDebugUrl() {
      var _this = this;

      this.generateDebugUrlLoading = true;
      makeDebugUrl({
        id: this.preview.id
      }).then(function (res) {
        _this.generateDebugUrlLoading = false;
        _this.$message({
          message: '生成成功',
          type: 'success'
        });
        _this.$nextTick(function () {
          _this.debug_html_url = res.data.data.debug_html_url;
          _this.preview.setRows && _this.preview.setRows({
            debug_html_url: _this.debug_html_url
          });
        });
      }).catch(function (res) {
        _this.generateDebugUrlLoading = false;
      });
    }
  }
};